import type { DisciplineScheduleChangeTutorPayload } from '../model/interfaces'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineScheduleChangeTutorApiOptions {
  disciplineId: string | number
  payload: DisciplineScheduleChangeTutorPayload
}

/** `POST /admin-api/disciplines/{discipline}/schedule/change-tutor` — assigns the new tutor and replaces the schedule
 *  from now; the lessons are rebooked in the background. */
export const useDisciplineScheduleChangeTutorApi = async (
  options: DisciplineScheduleChangeTutorApiOptions,
): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.disciplines.api.schedule.change-tutor', { discipline_id: options.disciplineId })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    await $axios.post(url, options.payload)
    toast.success({ title: 'Success!', description: 'Tutor was successfully changed' })

    return true
  } catch (err: unknown) {
    toast.error({ title: 'Error!', description: getAxiosErrorMessage(err) })
    return false
  }
}
